import { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import MemberService from "../../../../services/member_service";
import { useTenant } from "../../../../hooks/useTenant";

/**
 * useProfileData
 * 
 * Responsabilidade única: buscar e manter o estado do membro.
 * Retorna o membro, estado de loading/error e função de refresh.
 */
const useProfileData = () => {
    const { id } = useParams();
    const { idTenant, user, loading: tenantLoading } = useTenant();

    const [member, setMember] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchMember = useCallback(async (showLoader = true) => {
        if (!idTenant || !id) return;

        if (showLoader) setLoading(true);
        setError(null);
        try {
            const memberData = await MemberService.getMemberById(idTenant, id);
            if (memberData) {
                setMember(memberData);
            } else {
                setError(`Membro com ID ${id} não foi encontrado.`);
            }
        } catch (err) {
            console.error("Erro ao carregar perfil:", err);
            setError("Ocorreu um erro ao carregar os dados do perfil.");
        } finally {
            if (showLoader) setLoading(false);
        }
    }, [idTenant, id]);

    useEffect(() => {
        if (!tenantLoading) {
            fetchMember(true);
        }
    }, [tenantLoading, fetchMember]);

    return {
        member,
        setMember,
        loading: tenantLoading || loading,
        error,
        fetchMember,
        idTenant,
        user,
    };
};

export default useProfileData;
